module.exports = __webpack_public_path__ + "static/media/romobil_ikona.4a1b1977.png";